export default __webpack_public_path__ + "static/media/S_flex_2.7d642e19.pdf";